import React from 'react'
import dayjs from 'dayjs'
import FilterComponent from './FilterComponent'
import CalenderDatePickers from 'components/shared/calender-date-pickers'

export const FROM_OPERATOR = '>='
export const TO_OPERATOR = '<='
const INPUT_FORMAT = 'YYYY-MM-DD'

export default class DateFilter extends FilterComponent {
  state = {
    fromDate: this.fromDate,
    toDate: this.toDate
  }

  componentDidUpdate (prevProps) {
    const { filterValue } = this.props
    if (prevProps?.filterValue?.length !== 0 && filterValue?.length === 0) {
      // reset the local state when filter is reset
      this.setState({
        fromDate: '',
        toDate: ''
      })
    }
  }

  get fromDate () {
    return this.getDate(FROM_OPERATOR)
  }

  get toDate () {
    return this.getDate(TO_OPERATOR)
  }

  getDate (operator) {
    const [date] = this.getOperatorValue(operator)
    return date
      ? dayjs(date)
      : undefined
  }

  handleSubmit = () => {
    const { toDate, fromDate } = this.state
    this.props.setFilterValue([
      [fromDate ? [fromDate.format(INPUT_FORMAT)] : [], FROM_OPERATOR],
      [toDate ? [toDate.format(INPUT_FORMAT)] : [], TO_OPERATOR]
    ])
  }

  render () {
    const { toDate, fromDate } = this.state

    return (
      <CalenderDatePickers
        theme='dealwatch'
        showSubmitButton
        onHandleButtonSubmit={this.handleSubmit}
        fromDateSelected={fromDate}
        toDateSelected={toDate}
        disableSubmit={!(toDate || fromDate)}
        onHandleFromDateSelectedChange={val => this.setState({ fromDate: val })}
        onHandleToDateSelectedChange={val => this.setState({ toDate: val })}
      />
    )
  }
}
